import React, { useState, useEffect, useContext } from "react";
import useWindowDimensions from "../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import { colors } from "../../themes/Colors";
import { AuthContext } from "../../context/auth-context";
import { useNavigate } from "react-router-dom";
import {
  BuzzFeed,
  Profile,
  TabNavigator,
  More,
  Notification,
  UserPostRequestModal,
} from "./components";
import {
  BaseButtons,
  BaseButtonsIcon,
  IconOnlyButton,
  LoadingPopUp,
  ToastNotification,
  VehicleDisplayCrossModule,
} from "../common-components";
import SearchBar from "../common-components/search-bar/SearchBar";
import PcModule from "./pc-module/PcModule";
import AddVehiclePopUp from "../common-components/vehicle-display-cross-module/components/add-vehicle-pop-up/AddVehiclePopUp";
import { ManageVehicleView } from "../common-components/vehicle-display-cross-module/components";
import { LinkedUserPop } from "./components/more-screen/components";

const User = () => {
  const { width, height } = useWindowDimensions();
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  const [displayedTab, setDisplayedTab] = useState("buzz");

  const [toastPop, setToastPop] = useState(false);
  const [loading, setLoading] = useState(false);
  const [popUpTitle, setPopUpTitle] = useState("");
  const [message, setMessage] = useState("");

  const [refresh, setRefresh] = useState(false);

  const [buzzDisplay, setBuzzDisplay] = useState("today");

  const [subSelection, setSubSelection] = useState("dashboard");
  const [invitesArray, setInvitesArray] = useState(null);

  const [shareAccount, setShareAccount] = useState(null);

  const [privateInformation, setPrivateInformation] = useState(null);

  const [confirmShareAccount, setConfirmShareAccount] = useState(false);

  const [modulePopUp, setModulePopUp] = useState(false);

  const [adminRole, setAdminRole] = useState(null);
  const [agencyRole, setAgencyRole] = useState(null);

  const [postRequestModal, setPostRequestModal] = useState(false);

  const [liveFeed, setLiveFeed] = useState(null);
  const [historyFeed, setHistoryFeed] = useState(null);

  // business varibales
  const [businessData, setBusinessData] = useState(null);

  // this will be where the vehicle pop up varibles are
  const [vehicleAdd, setVehicleAdd] = useState(null);
  const [vehicleManageView, setVehicleManageView] = useState(null);

  // this will be the varibales for the linked users
  const [linkedUserPopUp, setLinkedUserPopUp] = useState(false);

  // this will be the varibales for the notices and message
  const [noticeArray, setNoticeArray] = useState([]);

  // https://driverfrienddatabase-h2aa.onrender.com/userInvites/getUserInvites
  const getUserInvites = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userInvites/getUserInvites",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            email: auth.customerUserData.email,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.invites.length >= 1) {
        setLoading(false);
        setInvitesArray(respnseData.invites);
        // setToastPop(true);
      } else {
        setLoading(false);
        setInvitesArray(respnseData.invites);
      }
    } catch (err) {
      setLoading(false);

      console.log("error", err);
    }
  };

  const GetShareAccount = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userInvites/getUserShareAccount",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            id: auth.customerUserData.userId,
            email: auth.customerUserData.email,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.shareAccount) {
        setLoading(false);
        setShareAccount(respnseData.shareAccount);
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage(
          "Could not find your share account please create one in your profile"
        );
        setLoading(false);
      }
    } catch (err) {}
  };

  const GetPrivateInformation = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL +
          "/privateInformation/getPersonalInfo",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth.customerUserData.userId,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setLoading(false);

        setPrivateInformation(respnseData.info);
      } else {
        setLoading(false);
      }
    } catch (err) {}
  };

  const CreateShareAccount = async () => {
    setConfirmShareAccount(false);
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL +
          "/userInvites/createUserShareAccount",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth.customerUserData.userId,
            username: auth.customerUserData.email,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setLoading(false);

        setRefresh(refresh ? false : true);
        // setToastPop(true);
      } else {
        setLoading(false);
        setShareAccount(null);
      }
    } catch (err) {
      setLoading(false);

      console.log("error", err);
    }
  };

  const ShareAccountRolesCheck = async () => {
    if (shareAccount) {
      await shareAccount.linkedRoles.map((role) =>
        role === "ADMIN" ? setAdminRole(true) : null
      );
      await shareAccount.linkedRoles.map((role) =>
        role === "AGENCY" ? setAgencyRole(true) : null
      );
      return {
        admin: adminRole,
        agency: agencyRole,
      };
    } else {
      setAdminRole(false);
      setAgencyRole(false);
    }
  };
  // this is user business functions
  const CheckForBusiness = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/thirdParty/getUserBusinessLink",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth.customerUserData.userId,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.business !== "No Business created") {
        setBusinessData(respnseData.business);

        // setToastPop(true);
      } else {
        setBusinessData(null);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const AdminNavigate = () => {
    if (adminRole && shareAccount) {
      navigate("/admin");
    }
  };
  const getLiveFeed = () => {
    setLoading(true);
    fetch(process.env.REACT_APP_BACKEND_URL + "/buzzPost/getTodaysFeed")
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setLiveFeed(resData.todaysPosts);
        setLoading(false);
      });
  };

  const getHistoricalFeed = () => {
    fetch(
      process.env.REACT_APP_BACKEND_URL + "/buzzPost/getApprovedPostHistory"
    )
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setHistoryFeed(resData.history);
        setLoading(false);
      });
  };

  const GetNoticesAndMessages = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userVehicles/getNoticesByUser",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth ? auth.customerUserData.userId : null,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setNoticeArray(respnseData.notices);
        // setToastPop(true);
      }
    } catch (err) {}
  };

  useEffect(() => {
    getLiveFeed();
    getHistoricalFeed();
  }, [refresh, displayedTab, buzzDisplay]);

  useEffect(() => {
    ShareAccountRolesCheck();
    if (
      !auth.isloggedIn ||
      auth.customerUserData.type === "Manager" ||
      auth.customerUserData.type === "Support" ||
      auth.customerUserData.type === "Investor"
    ) {
      // console.log("path check", admin.adminUserData.type);
      navigate("/");
    }
  }, [shareAccount]);

  useEffect(() => {
    if (toastPop) {
      setTimeout(() => {
        setToastPop(false);

        setTimeout(() => {
          setPopUpTitle("");
          setMessage("");
        }, 3000);
      }, 5000);
    }
  }, [toastPop]);
  useEffect(
    () => {
      GetPrivateInformation();
      GetShareAccount();
      getUserInvites();
      CheckForBusiness();
      GetNoticesAndMessages();
    },
    [subSelection, refresh],
    loading
  );

  return (
    <div
      style={{
        width: width,
        height: height,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        backgroundColor: colors.secondaryGrey,
        position: "relative",
      }}
    >
      {width > 599 ? (
        <PcModule
          height={height}
          width={width}
          auth={auth}
          user={auth.customerUserData}
          shareAccount={shareAccount}
          setConfirmShareAccount={setConfirmShareAccount}
          confirmShareAccount={confirmShareAccount}
          CreateShareAccount={CreateShareAccount}
          businessData={businessData}
          setLoading={setLoading}
          refresh={refresh}
          setRefresh={setRefresh}
          setModulePopUp={setModulePopUp}
          modulePopUp={modulePopUp}
          AdminNavigate={AdminNavigate}
          adminRole={adminRole}
          agencyRole={agencyRole}
          setPopUpTitle={setPopUpTitle}
          setMessage={setMessage}
          setToastPop={setToastPop}
          getUserInvites={getUserInvites}
          invitesArray={invitesArray}
          liveFeed={liveFeed}
          historyFeed={historyFeed}
          privateInformation={privateInformation}
        />
      ) : (
        <div
          style={{
            height: height,
            width: width,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flexDirection: "column",
            backgroundColor: colors.secondaryGrey,
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              height: 40,
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              // marginTop: 5,
            }}
          >
            <div
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                width: "100%",
                minHeight: 50,
                borderBottomRightRadius: 10,
                borderBottomLeftRadius: 10,
                backgroundColor: colors.greenLight,
                color: colors.white,
                fontWeight: "bold",
                transition: "all 0.3s",
                WebkitBoxShadow: "-5px 5px 15px -1px #00000070",
                // borderStyle: "solid",
                zIndex: 200,
                position: "relative",
              }}
            >
              <div style={{ marginLeft: 10, marginRight: 6 }}>
                {displayedTab.toLocaleUpperCase()}
              </div>
              <div> - {subSelection.toLocaleUpperCase()}</div>
              <div style={{ flex: 1 }}></div>

              {displayedTab === "more" ? (
                <div
                  style={{
                    height: 60,
                    width: 60,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: colors.greenDark,
                    position: "absolute",
                    right: 10,
                    top: 10,
                    borderRadius: "100%",
                    WebkitBoxShadow: "-5px 5px 15px -1px #00000070",
                  }}
                >
                  <IconOnlyButton
                    iconImage={require("../../images/icons/notificationsWhite.png")}
                    height={35}
                    width={35}
                    onClick={() => setSubSelection("notifications")}
                  />
                  {invitesArray ? (
                    invitesArray.length >= 1 ? (
                      <div
                        style={{
                          color: colors.white,
                          borderRadius: 100,
                          height: 25,
                          width: 25,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: colors.orangeDark,
                          position: "absolute",
                          top: 0,
                          left: -4,
                          fontWeight: "bold",
                        }}
                      >
                        {invitesArray.length}
                      </div>
                    ) : null
                  ) : null}
                </div>
              ) : (
                <div></div>
              )}
            </div>
          </div>
          {displayedTab === "buzz" ? (
            <div
              style={{
                width: "100%",
                // backgroundColor: colors.white,
                height: 55,
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                fontSize: 14,
                position: "relative",
              }}
            >
              <div
                onClick={() => setBuzzDisplay("today")}
                style={{
                  height: "100%",
                  flex: 0.3,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  // borderBottomStyle: "solid",
                  // borderWidth: buzzDisplay === "today" ? 3 : 0,
                  // borderColor: colors.greenLight,
                  transition: "all 0.3s",
                  WebkitBoxShadow:
                    buzzDisplay === "today"
                      ? "-5px 5px 15px -1px #00000070"
                      : "0px 0px 0px 0px #00000070",
                  borderBottomRightRadius: buzzDisplay === "today" ? 8 : 4,
                  borderBottomLeftRadius: buzzDisplay === "today" ? 8 : 4,
                  backgroundColor:
                    buzzDisplay === "today" ? colors.greenDark : colors.white,
                }}
              >
                <div
                  style={{
                    marginBottom: buzzDisplay === "today" ? -10 : 0,
                    fontWeight: buzzDisplay === "today" ? "bold" : "bold",
                    color: buzzDisplay === "today" ? colors.white : "#00000080",
                    transition: "all 0.3s",
                  }}
                >
                  TODAY
                </div>
              </div>

              <div
                onClick={() => setBuzzDisplay("forYou")}
                style={{
                  height: "100%",
                  flex: 0.3,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  // borderBottomStyle: "solid",
                  // borderWidth: buzzDisplay === "forYou" ? 3 : 0,
                  // borderColor: colors.greenLight,
                  transition: "all 0.3s",
                  WebkitBoxShadow:
                    buzzDisplay === "forYou"
                      ? "-5px 5px 15px -1px #00000070"
                      : "0px 0px 0px 0px #00000070",
                  borderBottomRightRadius: buzzDisplay === "forYou" ? 8 : 4,
                  borderBottomLeftRadius: buzzDisplay === "forYou" ? 8 : 4,
                  backgroundColor:
                    buzzDisplay === "forYou" ? colors.greenDark : colors.white,
                }}
              >
                <div
                  style={{
                    marginBottom: buzzDisplay === "forYou" ? -10 : 0,
                    fontWeight: buzzDisplay === "forYou" ? "bold" : "bold",
                    color:
                      buzzDisplay === "forYou" ? colors.white : "#00000080",
                    transition: "all 0.3s",
                  }}
                >
                  FOR YOU
                </div>
              </div>
              <div
                onClick={() => setBuzzDisplay("myPin")}
                style={{
                  height: "100%",
                  flex: 0.3,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  // borderBottomStyle: "solid",
                  // borderWidth: buzzDisplay === "forYou" ? 3 : 0,
                  // borderColor: colors.greenLight,
                  transition: "all 0.3s",
                  WebkitBoxShadow:
                    buzzDisplay === "myPin"
                      ? "-5px 5px 15px -1px #00000070"
                      : "0px 0px 0px 0px #00000070",
                  borderBottomRightRadius: buzzDisplay === "myPin" ? 8 : 4,
                  borderBottomLeftRadius: buzzDisplay === "myPin" ? 8 : 4,
                  backgroundColor:
                    buzzDisplay === "myPin" ? colors.greenDark : colors.white,
                }}
              >
                <div
                  style={{
                    marginBottom: buzzDisplay === "myPin" ? -10 : 0,
                    fontWeight: buzzDisplay === "myPin" ? "bold" : "bold",
                    color: buzzDisplay === "myPin" ? colors.white : "#00000080",
                    transition: "all 0.3s",
                  }}
                >
                  HISTORY
                </div>
              </div>
            </div>
          ) : null}
          {displayedTab === "buzz" ? (
            <div
              style={{ marginTop: 10, display: "flex", alignItems: "center" }}
            >
              <SearchBar
                size={"80%"}
                width={250}
                placeholder={"Type here to search for posts"}
              />
              <BaseButtonsIcon
                borderRadius={8}
                height={40}
                width={40}
                icon={require("../../images/icons/infoDarkBlue.png")}
                iconHeight={30}
                iconWidth={30}
                marginTop={5}
              />
              <div style={{ minWidth: 10 }} />
              <BaseButtonsIcon
                borderRadius={8}
                height={40}
                width={40}
                icon={require("../../images/icons/infoDarkBlue.png")}
                iconHeight={30}
                iconWidth={30}
                marginTop={5}
              />
            </div>
          ) : null}
          {displayedTab === "more" &&
          subSelection === "dashboard" &&
          shareAccount ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
              }}
            >
              <BaseButtons
                width={"90%"}
                label={"CHANGE MODULE"}
                backgroundColor={colors.greenDark}
                height={60}
                borderRadius={8}
                onClick={() => setModulePopUp(true)}
              />
              <div
                style={{
                  width: "100%",
                  backgroundColor: colors.white,
                  borderRadius: 8,
                  display: "flex",
                  flexDirection: "column",
                  position: "absolute",
                  justifyContent: "center",
                  alignItems: "center",
                  top: 0,
                  height: modulePopUp ? 240 : 0,
                  overflowY: "hidden",
                  zIndex: 100,
                  transition: "height 0.3s",
                }}
              >
                <BaseButtons
                  width={"90%"}
                  label={"GO TO ADMIN"}
                  backgroundColor={colors.greenDark}
                  height={50}
                  borderRadius={8}
                  disabled={adminRole ? false : true}
                  onClick={() => AdminNavigate()}
                />
                <div style={{ height: 20 }} />
                <BaseButtons
                  width={"90%"}
                  label={"GO TO AGENCY"}
                  backgroundColor={colors.greenDark}
                  height={50}
                  borderRadius={8}
                  disabled={agencyRole ? false : true}
                />
                <div style={{ height: 20 }} />
                <BaseButtons
                  width={"90%"}
                  label={"CANCEL"}
                  backgroundColor={colors.orangeDark}
                  height={50}
                  borderRadius={8}
                  onClick={() => setModulePopUp(false)}
                />
              </div>
            </div>
          ) : null}

          <div
            style={{
              flex: 1,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
            }}
          >
            <Profile
              height={height}
              display={displayedTab === "profile" ? true : false}
            />
            <BuzzFeed
              height={height}
              display={displayedTab === "buzz" ? true : false}
              buzzDisplay={buzzDisplay}
              liveFeed={liveFeed}
              historyFeed={historyFeed}
            />
            <More
              subSelection={subSelection}
              setSubSelection={setSubSelection}
              height={height}
              display={displayedTab === "more" ? true : false}
              user={auth ? auth.customerUserData : null}
              shareAccount={shareAccount}
              CreateShareAccount={CreateShareAccount}
              confirmShareAccount={confirmShareAccount}
              setConfirmShareAccount={setConfirmShareAccount}
              businessData={businessData}
              setLoading={setLoading}
              refresh={refresh}
              setRefresh={setRefresh}
              setMessage={setMessage}
              setToastPop={setToastPop}
              setPopUpTitle={setPopUpTitle}
              privateInformation={privateInformation}
              setLinkedUserPopUp={setLinkedUserPopUp}
            />
            <Notification
              display={subSelection === "notifications" ? true : false}
              onCloseClick={() => setSubSelection("dashboard")}
              auth={auth}
              getUserInvites={getUserInvites}
              invitesArray={invitesArray}
              setMessage={setMessage}
              setLoading={setLoading}
              setPopUpTitle={setPopUpTitle}
              setToastPop={setToastPop}
              refresh={refresh}
              setRefresh={setRefresh}
              noticeArray={noticeArray}
            />
            {displayedTab === "vehicle" ? (
              <VehicleDisplayCrossModule
                setLoading={setLoading}
                user={auth ? auth.customerUserData : null}
                width={width}
                type={"consumer"}
                setAddVehiclePopUp={setVehicleAdd}
                vehicleManageView={vehicleManageView}
                setVehicleManageView={setVehicleManageView}
                refresh={refresh}
                privateInformation={privateInformation}
                onCloseClick={() => {
                  setDisplayedTab("more");
                  setSubSelection("profile");
                }}
              />
            ) : null}
            {displayedTab === "buzz" ? (
              <div style={{ padding: displayedTab === "more" ? 60 : 40 }} />
            ) : null}
          </div>
          {displayedTab === "buzz" && !postRequestModal ? (
            <div
              style={{
                position: "fixed",

                bottom: 70,
                // zIndex: 10,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
              }}
            >
              <BaseButtons
                label={"POST REQUEST"}
                borderRadius={8}
                height={50}
                width={"90%"}
                backgroundColor={colors.orangeDark}
                color={colors.white}
                onClick={() => setPostRequestModal(true)}
              />
            </div>
          ) : null}
          <UserPostRequestModal
            display={postRequestModal}
            onCancelClick={() => setPostRequestModal(false)}
            height={height}
            setPostRequestModal={setPostRequestModal}
            auth={auth}
            setRefresh={setRefresh}
            refresh={refresh}
            setMessage={setMessage}
            setPopUpTitle={setPopUpTitle}
            setToastPop={setToastPop}
            setLoading={setLoading}
          />
          <TabNavigator
            selected={displayedTab}
            // onTaskClick={() => setDisplayedTab("task")}
            onBuzzClick={() => setDisplayedTab("buzz")}
            // onOffenceClick={() => setDisplayedTab("offence")}
            onVehicleClick={() => setDisplayedTab("vehicle")}
            onMoreClick={() => setDisplayedTab("more")}
          />
        </div>
      )}
      {width > 899 ? null : (
        <AddVehiclePopUp
          display={vehicleAdd}
          onCloseClick={() => setVehicleAdd(false)}
          width={"100%"}
          type={"org"}
          setVehicleAdd={setVehicleAdd}
          setLoading={setLoading}
          setMessage={setMessage}
          setPopUpTitle={setPopUpTitle}
          setToastPop={setToastPop}
          setRefresh={setRefresh}
          refresh={refresh}
          user={privateInformation ? privateInformation : null}
          auth={auth ? auth.customerUserData : null}
        />
      )}
      {width > 899 ? null : (
        <ManageVehicleView
          display={vehicleManageView}
          onCloseClick={() => setVehicleManageView(null)}
          height={height}
          auth={auth ? auth.customerUserData : null}
          setLoading={setLoading}
          setMessage={setMessage}
          setPopUpTitle={setPopUpTitle}
          setToastPop={setToastPop}
          setRefresh={setRefresh}
          refresh={refresh}
        />
      )}
      <LinkedUserPop
        setLoading={setLoading}
        setMessage={setMessage}
        setToastPop={setToastPop}
        setPopUpTitle={setPopUpTitle}
        auth={auth}
        display={linkedUserPopUp}
        setSubSelection={setSubSelection}
        setLinkedUserPopUp={setLinkedUserPopUp}
        loading={loading}
      />
      <LoadingPopUp display={loading} />
      <ToastNotification
        display={toastPop}
        title={popUpTitle}
        mainTitle={popUpTitle}
        message={message}
        width={width}
      />
    </div>
  );
};

export default User;
